// Display Settings — top-level redirect route.
// -----------------------------------------------------------------
// When the DISPLAY_SETTINGS flag is off (the default in both staging
// and prod), the route mounts and immediately <Navigate replace />s
// to /hello, matching the M3.4 placeholder pattern used by all
// other feature-flagged routes.
//
// When the flag is on, redirects to /display-settings/home-screen
// (the first and currently only sub-page). The trailing-underscore
// sibling file `display-settings_.home-screen.tsx` handles that URL
// without nesting under this route's component — same convention as
// `tour-planner_.$planId.tsx` vs `tour-planner.tsx`.

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { isFeatureEnabled } from '@/lib/featureFlags';

const DisplaySettingsRoute = () => {
  if (!isFeatureEnabled('DISPLAY_SETTINGS')) {
    return <Navigate to='/hello' replace />;
  }
  return <Navigate to='/display-settings/home-screen' replace />;
};

export const Route = createFileRoute('/_authenticated/display-settings')({
  component: DisplaySettingsRoute,
});
